import React, { Component } from "react"
// 导入css动画效果
import CSSTrans from "@/components/CSSTrans"
import "@/assets/styles/animates.scss"
// SwiperCore.use([Autoplay, Parallax]);
class Contact extends Component {
  state = {
    mySwiper_contact: null,
    contact_show: false,
  };
  componentDidMount() {
    this.props.componentRef(this, "contact")
  }
  render() {
    const contact_content = JSON.parse(this.props.contact_content)
    const recruit_list = JSON.parse(this.props.recruit)
    const contact_cooperation = JSON.parse(this.props.contact_cooperation)
    const wechat_tips = this.props.wechat_tips
    const lang = this.props.lang
    return (
      <div
        className={`recruit_contact ${lang === "en" ? "recruit_contact_en" : ""
          }`}
      >
        <div className="recruit_bg">
          <div>
            {CSSTrans(
              this.state.contact_show,
              "fadeInUp_trans",
              <h1 className="title">{contact_content.title}</h1>
            )}
            {CSSTrans(
              this.state.contact_show,
              "fadeInUp_trans",
              <div className="doc">{contact_content.doc}</div>
            )}
            <div className="recruit_container">
              {recruit_list.map((val, index) => (
                <div className="recruit_list" key={index}>
                  {CSSTrans(
                    this.state.contact_show,
                    "fadeInUp_trans",
                    <div>• {val}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="contact_bg">
          <div className="contact_container">
            {contact_cooperation.map((val, index) => (
              <div className="contact_box" key={index}>
                <div className="contact_title">{val.title}</div>
                {val.list.map((subVal, subIndex) => (
                  <div className="contact_list" key={subIndex}>
                    <img
                      src={require("@/assets/images/" + subVal.imgName).default}
                      alt=""
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    <span>{subVal.content}</span>
                  </div>
                ))}
              </div>
            ))}
            <div className="wechat">
              <img
                src={require("@/assets/images/wechat.jpg").default}
                alt=""
                style={{ width: "120px", margin: "0 auto 5px" }}
              />
              <div style={{ paddingLeft: "8px" }}>{wechat_tips}</div>
            </div>
          </div>
        </div>
        <div className="footer_bg">
          <div className="footer">
            <span>© 2025 YOOCAR. All rights reserved.</span>
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: 20 }}
            >
              <img
                src={require("@/assets/images/icp.png").default}
                alt=""
                style={{ display: 'inline-block', width: 15, height: 15, marginRight: 5, marginBottom: 2 }}
              />
              沪公网安备31010402333995号
              <span> ⋅ </span>
              沪ICP备2021011984号
            </a>
          </div>
        </div>
      </div>
    )
  }
}
export default Contact
